export enum CQWebappApi {
  DASHBOARD = 'dashboard',
  APP_ROUTER = 'app/router',

  GET_PROGRESS_MODE = 'callmode/list',
  UPDATE_PROGRESS_MODE = 'callmode/update',
  GET_DEVICE_TIME = 'device/calendar',
  GET_SERVICE_TIME = 'service/calendar',
  DEVICE_SERVICE = 'device/service/list',
  UPDATE_DEVICE_SERVICE = 'device/service/set',
  GET_OPERATOR_COUNTER = 'operator/device',
  MESSAGE_LIST = 'message/list',
  MESSAGE_UPDATE = 'message/update',
  MESSAGE_DELETE = 'message/delete',
  LOGIN = 'login',
  LOGOUT = 'logout',
  PASSWORD_CHANGE = 'password/change',

  ORGANIZATION_GET = 'organization/code',
  ORGANIZATION_LIST = 'organization/list',
  ORGANIZATION_DETAIL = 'organization/detail',
  ORGANIZATION_UPDATE = 'organization/update',
  HUB_LIST = 'organization/hub',
  HUB_GET = 'organization/code/hub',
  //CGM_CREATE_PHARMA           =   "cgm/create/pharma"             ,
  GUIDED_CREATE = 'create/complete',

  SITE_LIST = 'site/list',
  SITE_LIST_BY_SERVICE = 'site/servicecode',
  SITE_DETAIL = 'site/detail',
  SITE_CREATE = 'site/create',
  SITE_UPDATE = 'site/update',

  DEVICE_LIST = 'device/list',
  DEVICE_DETAIL = 'device/detail',
  DEVICE_UPDATE = 'device/update',
  DEVICE_CREATE = 'device/create',
  DEVICE_ACTIVATION = 'device/activation',

  DEVICE_CALENDAR = 'device/calendar',
  DEVICE_CALENDAR_STATUS = 'device/calendar/change/status',
  DEVICE_CALENDAR_UPDATE = 'device/calendar/update',
  DEVICE_CALENDAR_DELETE = 'device/calendar/delete',

  SERVICE_LIST = 'service/list',
  SERVICE_MIN_LIST = 'service/list/min',
  SERVICE_DETAIL = 'service/detail',
  SERVICE_CATEGORY = 'service/category',
  SERVICE_CALENDAR = 'service/calendar',
  SERVICE_CALENDAR_UPDATE = 'service/calendar/update',
  SERVICE_CALENDAR_STATUS = 'service/calendar/change/status',
  SERVICE_CALENDAR_DELETE = 'service/calendar/delete',
  SERVICE_CREATE = 'service/create',
  SERVICE_UPDATE = 'service/update',
  SERVICE_CHANGE_STATUS = 'service/change/status',

  OPERATOR_LIST = 'operator/list',
  OPERATOR_DETAIL = 'operator/detail',
  OPERATOR_ASSIGNABLE = 'operator/assignable/list',
  OPERATOR_ASSIGNED = 'operator/assigned/list',
  OPERATOR_LEVEL = 'operator/authorization/list',
  OPERATOR_CREATE = 'operator/create',
  OPERATOR_UPDATE = 'operator/update',
  OPERATOR_ASSIGN = 'operator/assign',
  OPERATOR_UNASSIGN = 'operator/unassign',
  OPERATOR_RESET_PASSWORD = 'operator/password/reset',

  MESSAGE_DETAIL = 'message/detail',
  MESSAGE_CREATE = 'message/create',

  SLOT_LIST = 'slot/list',
  SLOT_LIST_AQP = 'slot/list/aqp',
  SLOT_DAY = 'slot/day',
  SLOT_VISIBILITY = 'slot/visibility',
  SLOT_CREATE_PRENOTATION = 'slot/create/prenotation',
  SLOT_CREATE_PRENOTATION_AQP = 'slot/create/prenotation/aqp',
  SLOT_UPDATE_PRENOTATION = 'slot/update/prenotation',
  SLOT_UPDATE_PRENOTATION_AQP = 'slot/update/prenotation/aqp',
  SLOT_DELETE_PRENOTATION = 'slot/delete/prenotation',
  SLOT_DELETE_PRENOTATION_AQP = 'slot/delete/prenotation/aqp',
  SLOT_CREATE = 'slot/create',
  SLOT_UPDATE = 'slot/update',
  SLOT_DELETE = 'slot/delete',
  SLOT_DELETE_ALL = 'slot/delete/free',
  SLOT_MASS_IMPORT = 'slot/mass/import',

  PLACE_LIST = 'place/list',

  LICENCE_LIST = 'licence/list',
  LICENCE_ACTIVATE = 'licence/activate',
  LICENCE_DEACTIVATE = 'licence/deactivate',
  LICENCE_TOKEN = 'licence/token',
  LICENCE_ACTIVATE_ALL = 'licence/activate/all',
  LICENCE_EXTRACT_EXCEL = 'licence/excel',
  SLOT_TYPE_LIST = '',

  SLOTMODEL_AUTO_LIST = 'slot/model/auto/list',
  SLOTMODEL_LIST = 'slot/model/list',
  SLOTMODEL_AUTO = 'slot/model/automate',
  SLOTMODEL_DETAIL = 'slot/model/detail',
  SLOTMODEL_SLOT = 'slot/model/slot/create',
  SLOTMODEL_UPDATE = 'slot/model/update',
  SLOTMODEL_CREATE = 'slot/model/create',
  SLOTMODEL_APPLY = 'slot/model/apply',

  BOOKNUMBERING_LIST = 'book/numbering/list',
}
